"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _BestLink = _interopRequireDefault(require("../../../../elements/links/BestLink"));

var _Icon = _interopRequireDefault(require("../../../../elements/icons/Icon"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var IconFormatter = function IconFormatter(_ref) {
  var value = _ref.value,
      icon = _ref.icon,
      classes = _ref.classes,
      id = _ref.id,
      tooltip = _ref.tooltip;
  return _react["default"].createElement(_BestLink["default"], {
    to: value,
    id: id
  }, _react["default"].createElement(_Icon["default"], {
    iconName: icon,
    className: classes,
    title: tooltip
  }));
};

IconFormatter.propTypes = {
  value: _propTypes["default"].any.isRequired,
  icon: _propTypes["default"].string.isRequired,
  id: _propTypes["default"].string.isRequired,
  classes: _propTypes["default"].string,
  tooltip: _propTypes["default"].string
};
IconFormatter.defaultProps = {
  classes: "",
  tooltip: ""
};
var _default = IconFormatter;
exports["default"] = _default;